import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Divider, Form, Modal, Row, Switch, Tabs } from "antd";

import moment from "moment";

import { tenantDeletedService } from "./../../redux/services";

import {
	UIDrawerForm,
} from "./../../components";

const config = {
	externalName: "empresa",
};

class Show extends Component {
	static propTypes = {
		visible : PropTypes.bool.isRequired,
		onClose : PropTypes.func.isRequired,
		external: PropTypes.bool,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			uuid     : 0,
			item     : {},
		};
	}

	onOpen = (uuid) => {
		this.setState({
			isLoading: true,
			uuid     : uuid,
			item     : {},
		});

		tenantDeletedService.show({uuid})
		.then((response) => {
			let item = response.data.data;

			this.setState({
				isLoading: false,
				item     : item,
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
		this.setState({
			item: {},
		});
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	render() {
		const {visible}               = this.props;
		const {uuid, isLoading, item} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={700}
				onClose={this.onClose}
				isLoading={isLoading}
				showBtnSave={false}
				title={`Visualizar ${this.props.external ? config.externalName : "registro"} [${uuid}]`}>
				<Form layout="vertical">
					<Tabs defaultActiveKey="general">
						<Tabs.TabPane forceRender tab="Info. Gerais" key="general">
							<Divider orientation="left">Dados do empresa</Divider>
							<Form.Item label="Nome fantasia">
								{item.name}
							</Form.Item>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item label={item.document_type}>
										{item.document}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item label="Telefone">
										{item.phone ?? '-'}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={12} sm={8} xl={6}>
									<Form.Item label="CEP">
										{item.zipcode ?? '-'}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} sm={12} xl={10}>
									<Form.Item label="Endereço">
										{item.street ?? '-'}
									</Form.Item>
								</Col>
								<Col xs={10} sm={5}>
									<Form.Item label="Número">
										{item.number ?? '-'}
									</Form.Item>
								</Col>
								<Col xs={14} sm={7} xl={9}>
									<Form.Item label="Complemento">
										{item.complement ?? '-'}
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item label="Bairro">
										{item.district ?? '-'}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item label="Cidade">
										{item.city?.full_name ?? '-'}
									</Form.Item>
								</Col>
							</Row>
							<Divider orientation="left">Dados do responsável</Divider>
							<Form.Item label="Nome">
								{item.responsible}
							</Form.Item>
							<Form.Item label="E-mail">
								{item.responsible_email}
							</Form.Item>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item label="CPF">
										{item.responsible_document}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item label="Telefone">
										{item.responsible_phone}
									</Form.Item>
								</Col>
							</Row>
							<Divider />
							<Form.Item label="Ativo">
								<Switch disabled checked={item.is_active} />
							</Form.Item>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item label="Criação">
										{moment(item.created_at).calendar()}
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item label="Última atualização">
										{moment(item.updated_at).calendar()}
									</Form.Item>
								</Col>
							</Row>
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Show;
